import Overview from '@app/views/Overview';

import { RouteRenderProps } from '../utils';
import { WebRoutes } from '../constants';

export const homeRoutes: RouteRenderProps[] = [
  {
    path: WebRoutes.Main,
    render: <Overview />,
    fromParent: 0,
  },
];
